module.exports = __webpack_public_path__ + "static/img/1.8ef0f9c2.jpg";